/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Batch_Processing_JobInputs */



/**
* | output |
* | --- |
* | "Processing {name}…" |
*
* @param {Batch_Processing_JobInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const batch_processing_job = /** @type {((inputs: Batch_Processing_JobInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Batch_Processing_JobInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Traitement en cours ${i?.name}…`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Verarbeitung von ${i?.name}…`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Elaborazione ${i?.name}…`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Обработка ${i?.name}…`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Procesando ${i?.name}…`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`正在处理 ${i?.name}…`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.name} を処理中…`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.name} की प्रक्रिया जारी है…`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Processando ${i?.name}…`)
	return /** @type {LocalizedString} */ (`Processing ${i?.name}…`)
});